module.exports = "/virtual-football-league/img/odd-games.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/odd-games.png
// module id = 185
// module chunks = 4